export const network =
    window.location.hostname === "localhost"
        ? "http://localhost:3001"
        : "https://api.jettsplus.co.nz";
